export default function Dropdown () {
  const dropdown = document.querySelectorAll(".dropdown");
  if (dropdown.length === 0) return;

  const toggleDropdown = (dropdown, dropdownButton) => {
    const dropdownIcon = dropdown.querySelector(".dropdown__icon");
    const dropdownList = dropdown.querySelector(".dropdown__list");
    if (!dropdownIcon || !dropdownList) return;

    const closeDropdown = (e) => {
      if (e.target !== dropdownButton && e.target.parentNode !== dropdownButton) {
        dropdownList.classList.remove("dropdown__list--visible");
        dropdownIcon.classList.remove("dropdown__icon--open");
        dropdownButton.classList.remove("dropdown__button--open");
        dropdownIcon.classList.add("dropdown__icon--closed");
        document.removeEventListener('click', closeDropdown);
      }
    }

    if (dropdownList.classList.contains("dropdown__list--visible")) {
      dropdownList.classList.remove("dropdown__list--visible");
      dropdownIcon.classList.remove("dropdown__icon--open");
      dropdownIcon.classList.add("dropdown__icon--closed");
      dropdownButton.classList.remove("dropdown__button--open");
      document.removeEventListener('click', closeDropdown);
      return;
    }

    dropdownList.classList.add("dropdown__list--visible");
    dropdownIcon.classList.remove("dropdown__icon--closed");
    dropdownIcon.classList.add("dropdown__icon--open");
    dropdownButton.classList.add("dropdown__button--open");
    document.addEventListener('click', closeDropdown);
  }

  dropdown.forEach((dropdown) => {
    const dropdownButton = dropdown.querySelector(".dropdown__button");
    if (!dropdownButton) return;

    dropdownButton.addEventListener("click", () => toggleDropdown(dropdown, dropdownButton))
  });
}
